import React from 'react';
export const Header = () => {
  return <header className="w-full bg-gray-900 text-white py-2" data-id="element-264">
      <div className="max-w-6xl mx-auto flex justify-between items-center px-4" data-id="element-265">
        <div className="flex-1" data-id="element-266"></div>
        <div className="text-center flex-1 font-semibold text-lg" data-id="element-267">
          WOMEN'S HEALTH
        </div>
        <div className="flex-1 flex justify-end items-center" data-id="element-268">
          <div className="flex items-center" data-id="element-269">
            <div className="w-5 h-5 rounded-full overflow-hidden mr-2 flex items-center justify-center" data-id="element-270">
              <span className="text-lg" role="img" aria-label="USA flag" data-id="element-271">
                🇺🇸
              </span>
            </div>
            <span className="text-xs font-medium" data-id="element-272">Trending in the US</span>
          </div>
        </div>
      </div>
    </header>;
};